import {generateTableOfContent} from '@/_application/core/utils/common';
import {scrollToElement} from '@/_application/core/utils/scroll-to-element-by-id';
import {useEffect} from 'react';
import styles from './expand-description-content.module.css';
import cn from 'classnames';

interface Props {
    htmlDescription: string;
    isOpen: boolean;
}

const TABLE_CONTENT_LEVEL = 3; //table of content's max depth
const DISTANCE_ADJUSTMENT = -140;

function ExpandDescriptionContent({htmlDescription, isOpen}: Readonly<Props>) {
    const TableContentHtml = generateTableOfContent(htmlDescription, TABLE_CONTENT_LEVEL);

    useEffect(() => {
        const handleLiClick = (event: Event) => {
            if (!isOpen) {
                return;
            }
            event.preventDefault();
            const aTag = event.target as HTMLElement | null;
            if (!aTag) return;

            const targetName = aTag.getAttribute('name');
            const targetHeader = document.querySelector(`h2 a[name="${targetName}"], h3 a[name="${targetName}"]`);

            if (targetHeader) {
                scrollToElement(targetHeader, DISTANCE_ADJUSTMENT);
            }
        };
        const anchorTags = document.querySelectorAll('#toc a[name]');
        anchorTags.forEach(tag => {
            tag.addEventListener('click', handleLiClick);
        });

        return () => {
            anchorTags.forEach(tag => {
                tag.removeEventListener('click', handleLiClick);
            });
        };
    }, [isOpen]);

    return (
        <>
            {TableContentHtml && (
                <div className="mb-5 w-fit rounded-[10px] border border-KPZ_Gray_05 p-5">
                    <div className="main-content-category" dangerouslySetInnerHTML={{__html: TableContentHtml}} />
                </div>
            )}
            {!isOpen && (
                <div
                    style={{
                        backgroundImage: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255, 1) 90%)',
                    }}
                    className="pointer-events-none absolute bottom-0 left-0 z-1 h-20 w-full"></div>
            )}
            <div
                className={cn('my-2', styles['expand-description-content'])}
                dangerouslySetInnerHTML={{__html: htmlDescription}}
            />
        </>
    );
}

export default ExpandDescriptionContent;
